var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82792 1.42401C9.06192 -0.47467 12.2714 -0.47467 14.5054 1.42401L14.7123 1.44047C17.4903 1.66156 19.703 3.94882 19.9342 6.83823C21.7997 9.02137 21.7997 12.312 19.9342 14.4951C19.783 16.3852 18.7839 18.0176 17.3333 18.9825V25.3334C17.3333 26.0697 16.7364 26.6667 16 26.6667H15.3333C14.6666 26.6667 10.6666 25.3334 10.6666 25.3334C9.17562 25.8304 6.66662 26.6667 6.00002 26.6667H5.33333C4.59693 26.6667 4 26.0697 4 25.3334V18.9825C2.54944 18.0176 1.55034 16.3852 1.3991 14.4951C-0.466365 12.312 -0.466365 9.02137 1.3991 6.83823C1.6303 3.94882 3.84306 1.66156 6.62103 1.44047L6.82792 1.42401ZM18.6666 10.6667C18.6666 15.085 15.0849 18.6667 10.6666 18.6667C6.24843 18.6667 2.66667 15.085 2.66667 10.6667C2.66667 6.24838 6.24843 2.66666 10.6666 2.66666C15.0849 2.66666 18.6666 6.24838 18.6666 10.6667Z",
    fill: "#72F238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0026 10.6668C16.0026 13.6124 13.6148 16.0002 10.6693 16.0002C7.72374 16.0002 5.33594 13.6124 5.33594 10.6668C5.33594 7.7213 7.72374 5.3335 10.6693 5.3335C13.6148 5.3335 16.0026 7.7213 16.0026 10.6668Z",
    fill: "#72F238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.8c0dd5a664a04f1707284809ded088dc.svg";
export { ForwardRef as ReactComponent };